import { $http } from '@/utils/https';
import type { ActionContext } from 'vuex';
import type { RootState } from '@/store';
import type { Page } from '@/types/site';
import type { ISendContactFormPayload } from '@/store/modules/types/contact';

interface State {
  staticPage: Page | null;
  staticPageLoading: boolean;
}

const state: State = {
  staticPage: null,
  staticPageLoading: false
};

const getters = {
  staticPage: (state: State) => state.staticPage,
  staticPageLoading: (state: State) => state.staticPageLoading
};

const actions = {
  // eslint-disable-next-line no-unused-vars
  GET_PAGE: async ({ commit }: ActionContext<State, RootState>, slug: string) => {
    commit('SET_PAGE_LOADING', true);
    try {
      const response = await $http.get<{ data: Page }>(`v1/pages/${slug}`);
      const page = response.data.data;
      commit('SET_PAGE', page);
      return page;
    } catch (e) {
      throw e;
    } finally {
      commit('SET_PAGE_LOADING', false);
    }
  },

  // eslint-disable-next-line no-unused-vars
  GET_CONTACTS: async ({ commit }: any) => {
    try {
      const response = await $http.get(`v1/contact-page`);
      return response.data.data;
    } catch (e) {
      throw e;
    }
  },

  // eslint-disable-next-line no-unused-vars
  SEND_CONTACT_FORM: async ({ commit }: any, payload: ISendContactFormPayload) => {
    try {
      const response = await $http.post('v1/store_contact_form', payload);
      return response.data.data;
    } catch (e) {
      throw e;
    }
  },

  // eslint-disable-next-line no-unused-vars
  GET_ABOUT_US: async ({ commit }: any) => {
    try {
      const response = await $http.get(`v1/about-us-page`);
      return response.data.data;
    } catch (e) {
      throw e;
    }
  }
};

const mutations = {
  SET_PAGE(state: State, data: Page) {
    state.staticPage = data;
  },
  SET_PAGE_LOADING(state: State, status: boolean) {
    state.staticPageLoading = status;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
